// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1WWN2","footer":"ModalInfo_footer__2aKF1"};